import { Component, inject, OnInit } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { UsersFacade } from '@core/users';
import { BuildingsFacade } from '@modules/buildings/facades/buildings-facade.service';
import { filter, take } from 'rxjs';

@Component({
  standalone: false,
  selector: 'hm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly usersFacade = inject(UsersFacade);
  private readonly buildingsFacade = inject(BuildingsFacade);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None,
        ),
        take(1),
      )
      .subscribe(() => {
        this.usersFacade.loadCurrentUser();
        this.buildingsFacade.loadBuildingsData();
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationError))
      .subscribe((event) => {
        const error = (event as NavigationError).error;
        if (error?.name === 'ChunkLoadError') {
          window.location.assign((event as NavigationError).url);
        }
      });
  }
}
